import { gql } from '@apollo/client';

export const GET_CURRENT_USER_JSSIP_CONFIG = gql`
  query GetCurrentUserJssipConfig($workspaceId: ID!) {
    getCurrentUserJssipConfig(workspaceId: $workspaceId) {
      integrationId
      wsServer
      realm
      extensionId
      extension
      password
      displayName
      prefix
    }
  }
`;
